import { render, staticRenderFns } from "./FdmResult.vue?vue&type=template&id=08da2b1f&scoped=true"
import script from "./FdmResult.vue?vue&type=script&lang=js"
export * from "./FdmResult.vue?vue&type=script&lang=js"
import style0 from "./FdmResult.vue?vue&type=style&index=0&id=08da2b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da2b1f",
  null
  
)

export default component.exports